// Start Royal Weblab Custom JS
$(document).ready(function(){
//  Start Sticky Menu JS 
	$(window).scroll(function(){
  if ($(window).scrollTop() >= 200) {
    $('.header-wrapper').addClass('fixed-nav'); 
   }else{
    $('.header-wrapper').removeClass('fixed-nav');   
   }
 });
// 	End Sticky Menu JS
});
$(document).ready(function() {
  $('#index-slider').slick({
    prevArrow: '<div class="slick-arrow-wrapper slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-arrow-wrapper slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>',
    autoplay: true,
    autoplaySpeed: 5000,
    dots: false
  });
    
  $('.index-multiple-slider').slick({
    slidesToShow: 4,
    slidesToScroll: 1,    
    prevArrow: '<div class="slick-arrow-wrapper slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-arrow-wrapper slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
          arrows: false
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
  
  $('.index-blogs').slick({
    slidesToShow: 3,
    slidesToScroll: 1,    
    prevArrow: '<div class="slick-arrow-wrapper slick-prev"><i class="fa fa-chevron-left" aria-hidden="true"></i></div>',
    nextArrow: '<div class="slick-arrow-wrapper slick-next"><i class="fa fa-chevron-right" aria-hidden="true"></i></div>',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
          arrows: false
        }
      }
    ]
  });
});

   $(document).ready(function() {
    $('ul.tabs').each(function(){
      var active, content, links = $(this).find('a');
      active = links.first().addClass('active');
      content = $(active.attr('href'));
      links.not(':first').each(function () {
        $($(this).attr('href')).hide();
      });
      $(this).find('a').click(function(e){
        active.removeClass('active');
        content.hide();
        active = $(this);
        content = $($(this).attr('href'));
        active.addClass('active');
        content.show();
        return false;
      });
    });
  });

// START Accordion JS
(function($) {
    
  var allPanels = $('.accordion-sec > dd').hide();

  $('.accordion-sec > dt > a').click(function() {
    allPanels.slideUp();
    $('.accordion-sec > dt').removeClass('active-item');
    $(this).parent().next().slideDown();
    $(this).parent().toggleClass('active-item');
    return false;
    
  });


})(jQuery);
// END Accordion JS
// Start Labels Modal JS
// Get the modal

$('.lbl-swatches').on('click',function(){
 	 $(this).find('.modal-img')[0].click();
});

var cntImg = 1
$(".modal-img").each(function () {
  $(this).attr('id', function (index) {
        return "myImg" + cntImg;
    });
  cntImg++;
  var cntCap = 1;
  $('.caption').attr('id', function (index) {
        return "caption" + cntCap++;
    });
  
  
$('#labels-modal').append(`<div id="myModal" class="modal"><span class="close">&times;</span><img class="modal-content"><div class="caption"></div></div>`)
var cnt= 1;
$('.modal-content').attr('id', function (index) {
        return "img" + cnt++;
    });
  var countId= 1;
  $('.modal').attr('id', function (index) {
        return "myModal" + countId++;
    });

});
function range(start, end) {
  return Array(end - start + 1).fill().map((_, idx) => start + idx)
}
var array = range(1, 19);
var number = 0;
array.forEach(function(element){

var modal = document.getElementById("myModal" + array[element-1]);

// Get the image and insert it inside the modal - use its "alt" text as a caption
var img = document.getElementById("myImg" + array[element-1]);
var modalImg = document.getElementById("img" + array[element-1]);
var captionText = document.getElementById("caption" + array[element-1]);
img.onclick=function(){
modal.style.display = "block";
modalImg.src = this.src;
captionText.innerHTML = this.alt;
};
// Get the <span> element that closes the modal
var span = document.getElementsByClassName("close")[element-1];
// When the user clicks on <span> (x), close the modal
span.onclick = function() {
  modal.style.display = "none";
}
  number++;
});
// End Labels Modal JS
// End Royal Weblab Custom JS